{
  "version": 1,
  "asset_id": "d911a803-3e98-4ab5-a6d8-2c8241c42c20",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/d911a803-3e98-4ab5-a6d8-2c8241c42c20/wero.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/d911a803-3e98-4ab5-a6d8-2c8241c42c20/wero.png",
  "original_filename": "wero.png",
  "size": 11631,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:54:00Z"
}
